import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    h1: {
        id: "errorBoundry.h1",
    },
    h2: {
        id: "errorBoundry.h2",
    },
    reloadTooltipLabel: {
        id: "errorBoundry.tooltipLabel",
    },
    messageTooltipLabel: {
        id: "errorBoundry.messageTooltipLabel",
    },
    p: {
        id: "errorBoundry.p",
    },
    submit: {
        id: "general.send",
    },
    thankYou: {
        id: "errorBoundry.success",
    },
    commentsLabel: {
        id: "errorBoundry.commentsLabel",
    },
});

export default messages;
